import React, {
  useMemo,
} from "react";
import PropTypes from "prop-types";

import {
  createHorizontalRuler,
} from "../../../engines/StudioRulersEngine";


export default function HorizontalRuler({
  configuration,
  className = "",
}) {
  const ruler = useMemo(
    () => createHorizontalRuler(configuration),
    [configuration],
  );

  return (
    <div
      className={[
        "studio-ruler",
        "studio-ruler--horizontal",
        className,
      ].filter(Boolean).join(" ")}
      data-ruler-orientation="horizontal"
      aria-hidden="true"
    >
      {ruler.ticks.map((tick) => (
        <span
          key={`${tick.kind}:${tick.value}`}
          className={[
            "studio-ruler__tick",
            `studio-ruler__tick--${tick.kind}`,
          ].join(" ")}
          data-ruler-value={tick.value}
          style={{
            left: `${tick.position}px`,
          }}
        >
          {tick.label !== null && (
            <span className="studio-ruler__label">
              {tick.label}
            </span>
          )}
        </span>
      ))}
    </div>
  );
}


HorizontalRuler.propTypes = {
  configuration: PropTypes.shape({
    viewport: PropTypes.object,
    visibleStart: PropTypes.number.isRequired,
    visibleEnd: PropTypes.number.isRequired,
    origin: PropTypes.number,
    length: PropTypes.number.isRequired,
    minimumLabelSpacing: PropTypes.number,
    minorDivisions: PropTypes.number,
    unit: PropTypes.string,
    unitScale: PropTypes.number,
    formatter: PropTypes.func,
  }).isRequired,
  className: PropTypes.string,
};
